(function(){
  document.body.classList.add('ah-on-home');
  /* hamburger */
  var burger=document.querySelector('.ah-home .hamburger');
  var links=document.querySelector('.ah-home .nav-links');
  if(burger&&links){burger.addEventListener('click',function(){burger.classList.toggle('open');links.classList.toggle('open');});}
  /* to top */
  var tt=document.querySelector('.ah-home .to-top');
  if(tt){
    tt.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
    window.addEventListener('scroll',function(){tt.classList.toggle('show',window.scrollY>600);},{passive:true});
  }
  /* cart badge */
  fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
    var b=document.getElementById('cart-count');
    if(b){b.textContent=c.item_count||0;}
  }).catch(function(){});
  /* sticky nav shadow */
  var nav=document.querySelector('.ah-home .nav');
  if(nav){window.addEventListener('scroll',function(){nav.classList.toggle('stuck',window.scrollY>8);},{passive:true});}
})();
